import moment from 'moment-timezone'
import userTimeZone from 'utilities/userTimeZone'

export default (datetime, timezone) => {
  if (!timezone) timezone = userTimeZone()

  return moment(datetime).tz(timezone)
}
